import React, {
  useEffect, useRef, useState, lazy, Suspense,
} from 'react';
import propTypes from 'prop-types';
import mediacheck from 'mediacheck';
import NativeSelect from './NativeSelect';

const SearchableSelect = lazy(() => import(
  /* webpackChunkName: "SearchableSelect" */
  './SearchableSelect'
));

const Select = ({
  options,
  id,
  name,
  label,
  placeholder = 'Select...',
  onChange,
  isDisabled = false,
  shouldFocusInput = false,
  shouldClearSelection = false,
}) => {
  const [isTouchScreen, setIsTouchScreen] = useState(true);
  const [selectedOption, setSelectedOption] = useState();
  const selectRef = useRef();

  useEffect(() => {
    onChange?.(selectedOption?.value);
  }, [selectedOption, onChange]);

  useEffect(() => {
    if (shouldFocusInput && !isTouchScreen) {
      selectRef.current.focus();
    }
  }, [shouldFocusInput, isTouchScreen]);

  useEffect(() => {
    if (shouldClearSelection) {
      setSelectedOption(null);
    }
  }, [shouldClearSelection]);

  useEffect(() => {
    mediacheck({
      media: '(hover: hover) and (pointer: fine)',
      entry: () => setIsTouchScreen(false),
      exit: () => setIsTouchScreen(true),
    });
  }, []);

  if (isTouchScreen) {
    return (
      <NativeSelect
        id={id}
        label={label}
        name={name}
        value={selectedOption?.value ?? ''}
        onChange={(e) => setSelectedOption({
          label: e.target.options[e.target.selectedIndex].text,
          value: e.target.value,
        })}
        options={options}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
    );
  }

  return (
    <Suspense fallback={null}>
      <SearchableSelect
        value={selectedOption}
        options={options}
        id={id}
        label={label}
        name={name}
        placeholder={placeholder}
        onChange={setSelectedOption}
        isDisabled={isDisabled}
        ref={selectRef}
      />
    </Suspense>
  );
};

Select.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    value: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
  })),
  id: propTypes.string,
  name: propTypes.string,
  label: propTypes.string,
  placeholder: propTypes.string,
  onChange: propTypes.func,
  isDisabled: propTypes.bool,
  shouldFocusInput: propTypes.bool,
  shouldClearSelection: propTypes.bool,
};

export { Select };
